import React from "react";
import styled from "styled-components";

function Tile({ quantity, image, title, isLoading }) {
  if (isLoading)
    return (
      <Container>
        <Loading src={"/image/Loading2.gif"} />
      </Container>
    );

  return (
    <Container>
      <TileContent>
        <TileText>{quantity}</TileText>
        <TileImage src={image}></TileImage>
      </TileContent>
      <ContainerTileBottom>
        <TileTitleBottom>{title}</TileTitleBottom>
      </ContainerTileBottom>
    </Container>
  );
}

export default Tile;

const Loading = styled.img`
  margin-top: 35px;
  max-height: 60px;
  object-fit: contain;
  padding: 5px 5px 5px 5px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 10px;
  max-height: 150px;
  max-width: 220px;
  min-width: 220px;
  border: 1px solid black;
  align-items: center;
  border-radius: 4px;
  height: 150px;
  background: #ada996; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #eaeaea,
    #dbdbdb,
    #f2f2f2,
    #ada996
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #eaeaea,
    #dbdbdb,
    #f2f2f2,
    #ada996
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
`;

const ContainerTileBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  background-color: #424949;
`;

const TileTitleBottom = styled.span`
  display: flex;
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px 0px 5px 0px;
  font-size: 13px;
  color: #f4f6f7;
`;

const TileContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const TileImage = styled.img`
  max-height: 60px;
  object-fit: contain;
  padding: 5px 5px 5px 5px;
`;

const TileText = styled.div`
  font-size:25px;
  font-weight: 600;
  color: black;
`;
